module.exports = __webpack_public_path__ + "static/img/exhaust.3acc7b0.png";


//////////////////
// WEBPACK FOOTER
// ./img/project-design/exhaust.png
// module id = 1025
// module chunks = 1